import { render, staticRenderFns } from "./NhstIpRegistration.vue?vue&type=template&id=4d201700&scoped=true"
import script from "./NhstIpRegistration.vue?vue&type=script&lang=js"
export * from "./NhstIpRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d201700",
  null
  
)

export default component.exports